module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-bottom-segment-visualisation-middle.423feebc.png";